export class TipoAccesos {

  id: number;
  nombre: string;
  imagen: string;
  Visible: number;
  flagExterno: number;
  Orden: number;
  Descripcion: number;

  constructor(item: any) {
    this.id    = item.id_tipo_acceso;
    this.nombre  = item.nombre_tipo_acceso;
    this.imagen  = item.imagen_tipo_acceso;
    this.Visible = item.visible_tipo_acceso;
    this.flagExterno = item.flag_externo;
    this.Orden  = item.orden_tipo_acceso;
    this.Descripcion  = item.descripcion_tipo_acceso;
  }
}
